import React, { useEffect, useMemo, useRef, useState } from 'react';

import ExpandMore from '@material-ui/icons/ExpandMore';

import { useI18n } from 'Hooks';

import { standardColors } from './colors';
import { Bar, Icon, List, ListItem, OuterWrapper, SelectedColor, Text, Wrapper } from './styles';
export interface Props {
  name: string;
  selected?: { id: string; name?: string } | undefined;
  placeholder?: string;
  handleChange: (name: string, item: { id: string; name?: string }) => void;
}

const ColorSelect: React.FC<Props> = ({ name, selected = null, placeholder, handleChange }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const { t } = useI18n();

  const standardColorsData = useMemo(() => standardColors, [standardColors]);

  const onChange = (item: { id: string; name?: string }) => {
    if (selected?.id == item.id) {
      handleChange(name, { id: '' });
    } else {
      handleChange(name, item);
    }
    setOpen(false);
  };

  const handleClick = () => {
    if (standardColorsData.length > 0) {
      setOpen(!open);
    }
  };

  const handleDocClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocClick);

    return () => {
      document.removeEventListener('click', handleDocClick);
    };
  }, []);

  const checkKeyEnter = (e) => e.key === 'Enter' || e.key == ' ';

  const selectedInList = standardColorsData.find((item) => item.id == selected?.id);
  const selectedText = selectedInList ? selectedInList.name : selected?.name;

  return (
    <OuterWrapper ref={ref}>
      <Wrapper open={open}>
        <Bar
          onClick={handleClick}
          tabIndex={0}
          onKeyDown={(e) => checkKeyEnter(e) && handleClick()}>
          <Text active={Boolean(selectedText)}>
            <SelectedColor color={selected?.id} />
            <span>{selectedText || placeholder || t('General.Select')}</span>
          </Text>
          {standardColorsData.length > 0 && (
            <Icon open={open}>
              <ExpandMore htmlColor="#8b8f93" />
            </Icon>
          )}
        </Bar>
        {open && (
          <List open={open}>
            {standardColorsData.map((item, i) => (
              <ListItem
                key={i}
                onClick={() => onChange(item)}
                tabIndex={0}
                onKeyDown={(e) => checkKeyEnter(e) && onChange(item)}
                color={item.id}
                selected={item.id == selected?.id}
              />
            ))}
          </List>
        )}
      </Wrapper>
    </OuterWrapper>
  );
};

export default ColorSelect;
